import { IFormService } from "../../service/form/FormService";

export default class DeleteDraftVersionFormInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formVersionId: number) {
    return this.formService.deleteDraftVersionForm(formVersionId);
  }
}
